// @flow

import * as React from 'react';
import type {CalculationRequestProjectResult} from "../common/RequestTypes";

import CalculationSectionHeader from "./CalculationSectionHeader";
import TotalClimateEffectChart from './TotalClimateEffectChart';
import TotalClimateEffectWithDetailsChart from "./TotalClimateEffectWithDetailsChart";
import OptionManager from "../common/OptionManager";
import ClimateEffectDetailsTable from "./ClimateEffectDetailsTable";
import ClimateEffectOverviewTable from "./ClimateEffectOverviewTable";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {actionCreators} from "../store/Calculation";
import { history } from '../index';
import CalculationSectionSubHeader from "./CalculationSectionSubHeader";
import TotalClimateEffectPerPhaseChart from "./TotalClimateEffectPerPhaseChart";
import ClimateEffectOverviewPerPhaseTable from "./ClimateEffectOverviewPerPhaseTable";
import ProjectInfoTable from "./ProjectInfoTable";
import type {ProjectUiInput} from "../store/Calculation";
import ReactAI from 'react-appinsights';


type Props = {
    calcResult: CalculationRequestProjectResult,
    projectUiInput: ProjectUiInput
};

class CalculationResult extends React.Component<Props> {
    
    optionManager: OptionManager;
    
    constructor(props: Props) {
        super(props);
        this.optionManager = new OptionManager();
    }
    
    round(value: number, numDecimals: number): number {
        return parseFloat(value.toFixed(numDecimals));
    }

    componentDidMount() {
    }
    
    componentWillMount() {
        if(!this.props.calcResult) {
            history.push("/calculation");
            return null;
        }
    }
    
    navigateBack() {
        history.push("/calculation");
    }
    
    print() {
        window.print();
    }
    
    render() {
        if(!this.props.calcResult) 
            return null;
        
        const backEl = <button onClick={this.navigateBack} className="btn btn-primary print-hide"><span className="fas fa-arrow-left"> </span> Ange nya parametrar</button>;
        const printEl = <button onClick={this.print} className="btn btn-primary print-hide print-btn"><span className="fas fa-print"> </span> Skriv ut</button>;
        
        const totalDecreasePerCent = (this.props.calcResult.totalResult.totalTraditionalDiggingTonCO2 - this.props.calcResult.totalResult.totalNoDigTonCO2) / this.props.calcResult.totalResult.totalTraditionalDiggingTonCO2 * 100;
        const totalDecreaseTon = this.props.calcResult.totalResult.totalTraditionalDiggingTonCO2 - this.props.calcResult.totalResult.totalNoDigTonCO2;
        const totalDecreaseEl = <p className="lead">NoDig ger <strong><mark>{ this.round(totalDecreasePerCent, 0) } %</mark></strong> lägre utsläpp, { this.round(totalDecreaseTon, 0) } ton CO<sub>2</sub>e, än traditionell grävning.</p>;
        
        return (
            
            <div id="calculation-result" className="calculation-result" style={{paddingBottom: 30}}>

                <div className="page-to-print page-1">
                    <h1>Resultat</h1>
    
                    { totalDecreaseEl }
                    
                    { backEl }
                    { printEl }
    
                    <CalculationSectionHeader text="Projektinfo" />
                    <ProjectInfoTable calcResult={this.props.calcResult} projectUiInput={this.props.projectUiInput} optionManager={this.optionManager}/>
                </div>

                <div className="page-to-print page-2 page-break">
                    <CalculationSectionHeader text="Total klimatpåverkan för hela projektet" />
                    { totalDecreaseEl }
                    <TotalClimateEffectChart calculationResultDetails={this.props.calcResult.totalResult.totalDetailsKgCO2} />
    
                    <ClimateEffectOverviewTable calcResult={this.props.calcResult.totalResult}
                                                optionManager={this.optionManager} />
                </div>

                { this.props.calcResult.phaseResults.length > 1 && <div className="page-to-print page-3 page-break">
                    <CalculationSectionHeader text="Total klimatpåverkan per etapp" />
                    { totalDecreaseEl }
                    <TotalClimateEffectPerPhaseChart calcResult={this.props.calcResult} />
                    <ClimateEffectOverviewPerPhaseTable calcResult={this.props.calcResult}
                                                        optionManager={this.optionManager} />
                </div> }
                
                
                {this.props.calcResult.phaseResults.map((phaseResult, phaseIdx) => (phaseResult.techniquesToCompare && <div key={phaseIdx} className="phase-result page-to-print page-phase page-break">
                    
                                               
                        <CalculationSectionHeader text={`Detaljer ${this.props.calcResult.phaseResults.length > 1 ? 'etapp ' + (phaseIdx + 1) : ''}`} extraClass="ie10up"/>
                    
                        <CalculationSectionSubHeader text="Total klimatpåverkan per teknik och kategori" />
                        <TotalClimateEffectWithDetailsChart calculationResultDetails={phaseResult.totalDetailsKgCO2}
                                                            techniquesToCompare={phaseResult.techniquesToCompare}
                                                            optionManager={this.optionManager}
                                                            unit="kg CO₂e" />

                        <ClimateEffectDetailsTable calculationResultDetails={phaseResult.totalDetailsKgCO2}
                                                   techniquesToCompare={phaseResult.techniquesToCompare}
                                                   unit="kg CO<sub>2</sub>e"
                                                   optionManager={this.optionManager} />

                        <CalculationSectionSubHeader text="Per meter" />

                        <ClimateEffectDetailsTable calculationResultDetails={phaseResult.perMeterDetailsKgCO2}
                                                   techniquesToCompare={phaseResult.techniquesToCompare}
                                                   optionManager={this.optionManager}
                                                   unit="kg CO<sub>2</sub>e/m" />


                    </div>)
                )}                 
                
                <hr className="phase-delimiter print-hide" />
                
                { backEl }
                { printEl }

                <div className="print-header">
                    <div className="clearfix">
                        <div className="float-left">
                            <h2>Pollex Klimatkalkylator</h2>
                        </div>
                        <div className="float-right">
                            <img src="/images/logo-pollex.png" className="d-inline-block align-top" alt="Pollex logo"/>
                        </div>
                    </div>
                    <hr />
                </div>
                
                <div className="print-footer">
                    <hr />
                    <div className="clearfix">
                        <div className="float-right">
                            Pollex Klimatkalkylator version {this.props.projectUiInput.version}. Utskriven { new Date().toLocaleString() }
                        </div>
                    </div>
                </div>
                

            </div>
        );
    };
}

export default ReactAI.withTracking(connect(
    state => state.calculation,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(CalculationResult));




// WEBPACK FOOTER //
// ./src/components/CalculationResult.js